
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.438 1.934a6.321 6.321 0 00-3.246.918A6.983 6.983 0 002.71 4.049l.05-2.375a.333.333 0 00-.326-.34h-.007a.333.333 0 00-.333.326l-.07 3.27a.334.334 0 00.432.432l3.27-.07a.333.333 0 10-.006-.666H5.71l-2.677.057c.431-.496.938-.921 1.501-1.26A5.654 5.654 0 017.438 2.6c1.603 0 3.08.662 4.161 1.862.964 1.071 1.539 2.506 1.539 3.838 0 1.333-.575 2.767-1.539 3.838A5.537 5.537 0 017.44 14a5.477 5.477 0 01-2.688-.683 5.842 5.842 0 01-1.906-1.719.333.333 0 10-.543.387A6.513 6.513 0 004.428 13.9c.92.51 1.958.774 3.01.767 1.795 0 3.448-.74 4.657-2.083 1.07-1.19 1.71-2.79 1.71-4.284 0-1.492-.64-3.094-1.71-4.283a6.195 6.195 0 00-4.657-2.083z","fill":"#1E1E1E"}})])
          )
        }
      }
    